import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "icon chevron chevron-down",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = {
  key: 0,
  class: "col input-el"
}
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-el", {disabled: $props.state === 'view'}]),
    id: "color-selecter",
    disabled: ($props.state === 'view'),
    onMouseleave: $setup.close,
    onClose: $setup.close
  }, [
    _createElementVNode("div", {
      class: "row select",
      onClick: $setup.openClose,
      onBlur: $setup.close,
      onFocusout: $setup.close,
      onClose: $setup.close
    }, [
      _createElementVNode("span", {
        class: "chip",
        style: _normalizeStyle(`background-color:${$setup.selectedColor.code};`)
      }, null, 4),
      _createElementVNode("p", null, _toDisplayString($setup.selectedColor.name), 1),
      ($props.state !== 'view')
        ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[0] || (_cache[0] = [
            _createElementVNode("path", {
              class: "fill",
              d: "M16.59 8.59L12 13.17L7.41 8.59L6 10L12 16L18 10L16.59 8.59Z"
            }, null, -1)
          ])))
        : _createCommentVNode("", true)
    ], 32),
    ($setup.opened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.colors, (colour) => {
            return _createElementVNode("div", {
              key: `c-${colour.name}`,
              class: "row",
              onClick: ($event: any) => ($setup.makeSelection(colour))
            }, [
              _createElementVNode("span", {
                class: "chip",
                style: _normalizeStyle(`background-color:${colour.code};`)
              }, null, 4),
              _createElementVNode("p", null, _toDisplayString(colour.name), 1)
            ], 8, _hoisted_4)
          }), 64))
        ]))
      : _createCommentVNode("", true)
  ], 42, _hoisted_1))
}